import {Injectable} from '@angular/core';
import {HttpInterceptorService, RESTService} from '@covalent/http-deprec';
import {environment} from '../../../../environments/environment';
import {Observable, of} from 'rxjs';
import {Geschaeftsvorgang, Lieferung} from './Model/Lieferung';


@Injectable()
export class CsvDownloadService extends RESTService<Lieferung[]> {

  constructor(public http: HttpInterceptorService) {
    super(http, {
      baseUrl: `${environment.apiHost}`,
      path: '/makpak/dummy'
    });
  }

  // getCSVData(packageID: number):Observable<Process[]>{
  //   let urlParam = `${packageID}`;
  //   return super.get(urlParam).map((res:Process[])=>{
  //     return res;
  //   });
  // }

  getCSVData(): Observable<Geschaeftsvorgang[]> {
    let processes = [new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
      new Geschaeftsvorgang("id", "test", "test", "test", "test"),
    ];
    return of(processes);
  }

  getCSVDataGeschaeftsvorgang(gv: Geschaeftsvorgang[]): Observable<Geschaeftsvorgang[]> {
    return of(gv);
  }

}
